module.exports = __webpack_public_path__ + "img/logo_small.b1209009.png";